import React, { useState } from "react";
import {
  Collapse,
  List,
  ListItem,
  ListItemText,
  withStyles,
} from "@material-ui/core";
import { ExpandLess, ExpandMore } from "@material-ui/icons";
import style from "style";
import Item from ".";

const ParentItem = ({ classes, title, subItems, onClick = () => {} }) => {
  const [isOpen, setIsOpen] = useState(false);

  const onToggle = () => {
    setIsOpen((prev) => !prev);
  };
  return (
    <List component="div" disablePadding>
      <ListItem button onClick={onToggle}>
        <ListItemText primary={title} />
        {isOpen ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse
        style={{ paddingLeft: 10 }}
        in={isOpen}
        timeout="auto"
        unmountOnExit
      >
        {/* children here */}
        {subItems.map((item) => {
          return <Item {...item} onClick={onClick} />;
        })}
      </Collapse>
    </List>
  );
};

export default withStyles(style)(ParentItem);
